import React from 'react'
import Group from '@mui/icons-material/Group'
import { MapPinTypeVariant, type MapPinProps } from '../types'

export function MapPinIcon({
  variant,
  size = 24,
  color = 'white',
  isGroup,
}: Pick<MapPinProps, 'variant'> & {
  size?: number
  color?: string
  isGroup: boolean
}) {
  if (isGroup) {
    return <Group sx={{ fontSize: size, fill: color }} />
  }
  switch (variant) {
    case 'lead':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
        >
          <path
            d="M5 5C6.38125 5 7.5 3.88125 7.5 2.5C7.5 1.11875 6.38125 0 5 0C3.61875 0 2.5 1.11875 2.5 2.5C2.5 3.88125 3.61875 5 5 5ZM5 6.25C3.33125 6.25 0 7.0875 0 8.75V10H10V8.75C10 7.0875 6.66875 6.25 5 6.25Z"
            fill={color}
          />
        </svg>
      )
    case 'pendinglead':
    case 'draftlead':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="11"
          viewBox="0 0 16 11"
          fill="none"
        >
          <path
            d="M9.625 5.5C11.1444 5.5 12.375 4.26938 12.375 2.75C12.375 1.23062 11.1444 0 9.625 0C8.10562 0 6.875 1.23062 6.875 2.75C6.875 4.26938 8.10562 5.5 9.625 5.5ZM3.4375 4.125V2.0625H2.0625V4.125H0V5.5H2.0625V7.5625H3.4375V5.5H5.5V4.125H3.4375ZM9.625 6.875C7.78937 6.875 4.125 7.79625 4.125 9.625V11H15.125V9.625C15.125 7.79625 11.4606 6.875 9.625 6.875Z"
            fill={color}
          />
        </svg>
      )
    case 'opportunity':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="13"
          viewBox="0 0 7 13"
          fill="none"
        >
          <path
            d="M3.7675 5.43125C2.20688 5.02562 1.705 4.60625 1.705 3.95312C1.705 3.20375 2.39937 2.68125 3.56125 2.68125C4.785 2.68125 5.23875 3.26562 5.28 4.125H6.79937C6.75125 2.9425 6.02937 1.85625 4.5925 1.50563V0H2.53V1.485C1.19625 1.77375 0.12375 2.64 0.12375 3.96688C0.12375 5.555 1.43687 6.34562 3.355 6.80625C5.07375 7.21875 5.4175 7.82375 5.4175 8.46313C5.4175 8.9375 5.08062 9.69375 3.56125 9.69375C2.145 9.69375 1.58813 9.06125 1.5125 8.25H0C0.0825 9.75563 1.21 10.6013 2.53 10.8831V12.375H4.5925V10.8969C5.93313 10.6425 6.99875 9.86563 6.99875 8.45625C6.99875 6.50375 5.32812 5.83687 3.7675 5.43125Z"
            fill={color}
          />
        </svg>
      )
    case MapPinTypeVariant.PestPac:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 19 19"
          fill="none"
        >
          <path
            d="M9.28906 0.25C14.2809 0.250182 18.3271 4.29717 18.3271 9.28906C18.327 14.2809 14.2808 18.3279 9.28906 18.3281C4.29719 18.3281 0.250123 14.281 0.25 9.28906C0.25 4.29705 4.29711 0.25 9.28906 0.25Z"
            fill="#19305A"
            stroke="white"
            strokeWidth="0.5"
          />
          <path
            d="M17.8637 11.7977H17.2102V10.3447L18.1886 10.058C18.2095 9.80746 18.2213 9.55334 18.2203 9.29741C18.2194 8.91261 18.194 8.53324 18.145 8.16114L17.2075 8.43523C17.183 6.90961 16.349 5.57277 15.1174 4.83674L15.3234 4.30309C15.3806 4.15425 15.4913 4.02901 15.6347 3.95096L16.162 3.66508C15.9823 3.45089 15.7917 3.24578 15.5921 3.04975L14.9586 3.39281C14.8152 3.47086 14.7045 3.59519 14.6473 3.74494L14.3633 4.48098C13.9167 4.32124 13.4366 4.23412 12.9375 4.23412H12.7877C12.3594 4.23412 11.9455 4.29856 11.5544 4.41745L11.2957 3.79214C11.2349 3.6442 11.1215 3.52168 10.9754 3.44726L8.7564 2.30918C8.55674 2.20662 8.29899 2.26017 8.18283 2.44713C8.0594 2.64679 8.13473 2.90272 8.34528 3.01072L10.3138 4.02084C10.459 4.09526 10.5724 4.21778 10.6341 4.36572L10.7875 4.736C9.46247 5.4439 8.55039 6.82975 8.51953 8.42252L7.62559 8.16114C7.30976 8.06857 7.03296 7.87345 6.84691 7.61116L5.6562 5.93761C5.37214 5.53919 4.82307 5.40215 4.40469 5.62723C4.16873 5.75429 3.99902 5.9721 3.94002 6.22622C3.88194 6.47489 3.93458 6.73808 4.08342 6.94773L5.63352 9.12588C5.84407 9.42084 6.15445 9.64047 6.5093 9.74484L8.51862 10.3329V11.7987H4.85574C4.29397 11.7987 3.83838 12.2388 3.83838 12.7815C3.83838 13.3243 4.29397 13.7644 4.85574 13.7644H8.51953V14.9715C8.51953 15.0169 8.52134 15.0623 8.52316 15.1076L6.51021 15.6966C6.15536 15.8001 5.84497 16.0206 5.63442 16.3156L5.16068 17.1566C5.71519 17.467 6.30692 17.7184 6.92768 17.9035C7.10919 17.6921 7.35332 17.3584 7.62741 17.2785L8.97603 16.8837C9.20382 17.3348 9.50876 17.7405 9.8736 18.0826C10.7503 18.04 11.5934 17.8684 12.3848 17.5871V9.42447H9.45884V8.32723C9.45884 7.13651 10.1223 6.08918 11.1097 5.51106L11.5625 6.60649C11.5816 6.65187 11.6079 6.69271 11.6397 6.72719C11.7613 6.85788 11.9655 6.90326 12.1416 6.81614C12.3367 6.71993 12.4111 6.48669 12.3303 6.29066L11.872 5.18161C12.186 5.08814 12.52 5.03822 12.8649 5.03822C13.2878 5.03822 13.6935 5.11445 14.0683 5.2524L13.6771 6.26615C13.6009 6.464 13.6817 6.69634 13.8786 6.788C14.0565 6.87059 14.2589 6.82158 14.3778 6.68817C14.4086 6.65277 14.434 6.61193 14.4522 6.56656L14.8116 5.6354C15.6919 6.23166 16.27 7.21819 16.27 8.32904V9.42629H13.345V17.1796C15.5122 16.1014 17.1694 14.1556 17.8637 11.7977Z"
            fill={color}
          />
          <path
            d="M13.3402 9.43104H16.2653V8.33379C16.2653 7.22293 15.6863 6.23641 14.8068 5.64015L14.4474 6.5713C14.4302 6.61759 14.4048 6.65843 14.373 6.69292C14.2541 6.82633 14.0518 6.87625 13.8739 6.79275C13.6769 6.70109 13.5962 6.46966 13.6724 6.2709L14.0636 5.25715C13.6887 5.1192 13.2831 5.04297 12.8601 5.04297C12.5153 5.04297 12.1822 5.09379 11.8673 5.18636L12.3256 6.29541C12.4064 6.49144 12.331 6.72559 12.1368 6.82088C11.9608 6.90801 11.7575 6.86263 11.6349 6.73194C11.6032 6.69746 11.5769 6.65662 11.5578 6.61124L11.1049 5.51581C10.1175 6.09393 9.4541 7.14125 9.4541 8.33198V9.42922H12.3791V17.5918C12.7095 17.4748 13.0299 17.3377 13.3411 17.1834L13.3402 9.43104Z"
            fill="#19305A"
          />
        </svg>
      )
    case 'mixed':
      return <Group sx={{ fontSize: size, fill: color }} />
    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
        >
          <path
            d="M5 5C6.38125 5 7.5 3.88125 7.5 2.5C7.5 1.11875 6.38125 0 5 0C3.61875 0 2.5 1.11875 2.5 2.5C2.5 3.88125 3.61875 5 5 5ZM5 6.25C3.33125 6.25 0 7.0875 0 8.75V10H10V8.75C10 7.0875 6.66875 6.25 5 6.25Z"
            fill={color}
          />
        </svg>
      )
  }
}
